<div class="bp-asset-list">
  @if (viewModel$ | async; as viewModel) {
    @let mT = viewModel.vm.marginTrading;
    <div class="bp-asset-list-search-bar">
      <bp-search-bar
        (searchValueChange)="onSearchValueChange($event)"
      [placeholder]="'search_bar_placeholder_buy' | translate"></bp-search-bar>
    </div>
    <div class="bp-asset-list-filter">
      <bp-toggle-group
        [options]="viewModel.vm.pills.allPills"
        [selected]="viewModel.vm.pills.selectedPill"
        (onValueChange)="onFilterChange($event, mT.isMarginSelected)">
      </bp-toggle-group>
    </div>
    <!-- Risk Summary needed for UK -->
		<app-uk-risk-summary [classes]="'mb-20'"></app-uk-risk-summary>
		<!-- Performance Indicators needed for UK -->
		<performance-indicators-notification
			[classes]="'mb-20'">
		</performance-indicators-notification>
    @if (pillsThatNeedRealSecuritiesBanner | include_pipe: viewModel.vm.pills.selectedPill.value) {
      <div class="margin_security_banner">
        @if (isPriceOrder) {
          <real-securities-banner
            [title]="'inline_banner_real_securities_limit_orders_title' | translate"
            [subtitle]="'go_to_mobile_app_cta' | translate" />
        } @else {
          @let realSecuritiesRedirectionType = (realSecuritiesRedirectionType$ | async).value;
          @if (realSecuritiesRedirectionType === REDIRECTION_TYPE.PLAN_A) {
            <real-securities-banner
              [title]="'inline_banner_real_securities_trade_title' | translate: [getRSFeeText()]"
              [subtitle]="'inline_banner_real_securities_trade_subtitle' | translate"
              [linkTitle]="'discover_stocks_cta' | translate"
              [linkURL]="getV4RedirectURL()" />
          } @else if (realSecuritiesRedirectionType === REDIRECTION_TYPE.PLAN_B) {
            <real-securities-banner
              [title]="'inline_banner_real_securities_plan_b_title' | translate: [getRSFeeText()]"
              [subtitle]="'inline_banner_real_securities_coming_soon_web' | translate" />
          }
        }
      </div>
    }
    @if (viewModel.buyAgainList.length > 0 && viewModel.vm.showBuyAgain) {
      <div class="bp-asset-list-buy-again">
        <div class="buy-again-title">
          {{ "buy_again" | translate }}
        </div>
        <buy-again [tradables]="viewModel.buyAgainList" (onTradableClick)="onClick($event)"></buy-again>
      </div>
    }
    @if (viewModel.vm.marginTrading.showDropdown) {
      <div class="margin-trading-switcher">
        <mt-type-switcher
          [selectedOption]="viewModel.vm.marginTrading.leverageType"
          (selectedOptionChange)="onLeverageTypeChange($event)"
          (selectboxClicked)="trackLeverageSelectionClicked()" />
      </div>
    }
    <div class="bp-asset-list-table">
      <bp-table
        [items]="viewModel.vm.tradables"
        [(scrollToTop)]="scrollToTop"
        (itemClicked)="onClick($event, mT.isMarginSelected)"
        (scrolledToBottom)="onScrolledToBottom(mT.isMarginSelected, mT.hasNextPage, mT.after)"
        matSort
        (matSortChange)="onSortChange($event)">
        <ng-template [bpTableHeader]="viewModel.vm.tradables">
          <div bpTableHeaderCell mat-sort-header="name">
            {{ "all_charts_price_column_label_name" | translate }}
          </div>
          <div bpTableHeaderCell mat-sort-header="change">
            {{ "all_charts_price_column_label_change" | translate }}
            <span
              class="bp-table-disclaimer bpi__icon-info"
            [bp-tooltip]="'tradable_list_selection_change_tooltip_info' | translate"></span>
          </div>
          <div bpTableHeaderCell mat-sort-header="price">
            {{ "all_charts_price_column_label_price" | translate }}
          </div>
        </ng-template>
        <ng-template [bpTableRow]="viewModel.vm.tradables" let-tradable>
          <div bpTableCell>
            <img
              bpTableCellLogo
              [src]="tradable.getLogo()"
              (error)="img.src = tradable.getDefaultLogo()"
              alt="{{ 'logo_alt_text' | translate }}"
              #img />
            <div class="flex flex-col text-color">
              <div bpTableCellLine bpTableOverflowEllipsis>
                {{ tradable.getName() }}
              </div>
              <div bpTableCellLine>
                {{
                mT.isMarginSelected
                ? ("up_to" | translate: [tradable.getInfo()])
                : tradable.getSymbol(false, true)
                }}
              </div>
            </div>
          </div>
          <div bpTableCell>
            <bp-value-change [value]="getChangePercent(tradable)">
              {{ getChangePercent(tradable) | fiat_precision | add_number_prefix | percent_symbol }}
            </bp-value-change>
          </div>
          <div bpTableCell class="bp-asset-list-price text-color">
            @if (!isIndex(tradable)) {
              {{
              tradable.getPrice()
              | euro_to_user_fiat
              | fiat_precision_symbol
              : {
              id: defaultFiat.getId(),
              currencies: [defaultFiat, tradable],
              symbol: true
            }
            }}
          } @else {
            {{
            tradable.getPrice()
            | fiat_precision_symbol
            : {
            id: defaultFiat.getId(),
            currencies: [defaultFiat, tradable],
            symbol: true,
            removeCurrency: true
          }
          }}
        }
      </div>
    </ng-template>
  </bp-table>
</div>
} @else {
  <loading-spinner></loading-spinner>
}
</div>
